import React, {useCallback, useRef, useState} from 'react'

import EntitySelectorSearch from "../../search/search"
import EntitySelectorListTab from "../list-tab"
import {entitySelectorLoadDocumentItems} from "./load-documents"

// const debug = "EntitySelectorDocuments"
const debug = false

// One flat list, no sub-tabs: a document has nothing to browse into.
export default function EntitySelectorDocuments() {
    const [search, setSearch]   = useState('')
    const listRef               = useRef<any>()

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    const onKeyDown = useCallback((event: any)=>{
        listRef.current?.onKeyDown(event)
    }, [])

    debug && console.log(debug, 'render', search)

    return (
        <>
            <EntitySelectorSearch
                onKeyDown           = {onKeyDown}
                onSearchChanged     = {onSearchChanged}
            />

            <EntitySelectorListTab
                ref             = {listRef}
                search          = {search}
                titleLabel      = "Title"
                dateLabel       = "Last updated"
                noItemsMessage  = "No documents found"
                loadItems       = {entitySelectorLoadDocumentItems}
            />
        </>
    )
}
